import { useEffect, useState } from "react";

/** How long a price request may take before the page stops saying "Working out your price…" and offers a retry. */
export const PRICE_STALLED_AFTER_MS = 20_000;

/**
 * True once `isWaiting` has been true for `afterMs` without a break. `waitKey` names what is being waited
 * for: when it changes (a new request replaced the old one while still waiting) the wait starts again, so a
 * new request gets its own full wait. The answer arriving, or `isWaiting` turning false, clears it at once.
 */
export function useIsStalled(
  isWaiting: boolean,
  waitKey: unknown,
  afterMs: number = PRICE_STALLED_AFTER_MS,
): boolean {
  const [isStalled, setIsStalled] = useState(false);
  useEffect(() => {
    setIsStalled(false);
    if (!isWaiting) return;
    const timer = setTimeout(() => setIsStalled(true), afterMs);
    return () => clearTimeout(timer);
  }, [isWaiting, waitKey, afterMs]);
  return isWaiting && isStalled;
}
